var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[_c('v-row',{attrs:{"dense":""}},[(_vm.progressIsPinned)?_c('v-col',{attrs:{"cols":"12"}}):_vm._e(),_c('v-col',{staticClass:"pb-4 px-4",attrs:{"cols":"12"}},[_c('Log')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }